// App Constants

// 9 price tiers (20-80 USDT)
export const PRICE_TIERS = [
  { price: 20, label: '$20', display: '$20' },
  { price: 25, label: '$25', display: '$25' },
  { price: 30, label: '$30', display: '$30' },
  { price: 35, label: '$35', display: '$35' },
  { price: 40, label: '$40', display: '$40' },
  { price: 50, label: '$50', display: '$50' },
  { price: 60, label: '$60', display: '$60' },
  { price: 70, label: '$70', display: '$70' },
  { price: 80, label: '$80', display: '$80' }
];

// Contract now supports 30 matrix levels (0.025% for L1-L15, 0.01% for L16-L30)
export const MATRIX_LEVELS = 30;
export const PROFIT_CEILING = 200;

// Required direct-auto business (USDT) to unlock level income
// L1-L15 threshold (lower) — used for the basic eligibility progress bar
export const DIRECT_AUTO_BUSINESS_REQUIRED = 100;
// L16-L30 requires more ($1000) but that's enforced on-chain; frontend shows L1-L15 threshold

// Required number of direct referrals to unlock matrix (legacy display threshold)
export const DIRECT_REFERRAL_REQUIRED = 5;

// Navigation Items
export const NAV_ITEMS = [
  { path: '/', label: 'Home', icon: 'home' },
  { path: '/my-nfts', label: 'My NFTs', icon: 'nft' },
  { path: '/team', label: 'Team', icon: 'team' }
];
